import { Campo } from "../../components/ui/primitivos";
import { ACEPTA_ARCHIVO_FISCAL, validarArchivoFiscal } from "./archivo-fiscal";

/**
 * El input del comprobante o de la nota de crédito (ADR 0099 C2). Valida al
 * elegir: un archivo que no sirve no queda elegido y el motivo se dice ahí,
 * antes de mandar nada.
 */
export function CampoArchivoFiscal({
  etiqueta,
  name,
  alElegir,
  alRechazar,
}: {
  etiqueta: string;
  name: string;
  alElegir: (archivo: File | null) => void;
  alRechazar: (motivo: string) => void;
}) {
  return (
    <Campo
      etiqueta={etiqueta}
      name={name}
      type="file"
      accept={ACEPTA_ARCHIVO_FISCAL}
      ayuda="PDF, JPG o PNG, hasta 10 MB."
      onChange={(e) => {
        const archivo = e.target.files?.[0] ?? null;
        const motivo = archivo ? validarArchivoFiscal(archivo) : null;
        if (motivo) {
          // Se limpia para que el input no muestre elegido algo que no se va a mandar.
          e.target.value = "";
          alRechazar(motivo);
          alElegir(null);
          return;
        }
        alElegir(archivo);
      }}
      required
    />
  );
}
